/* eslint-disable react/no-danger */

/* eslint-disable @typescript-eslint/ban-ts-comment */

/* eslint-disable react/jsx-props-no-spreading */
import hljs from 'highlight.js';
import javascript from 'highlight.js/lib/languages/javascript';
import typescript from 'highlight.js/lib/languages/typescript';
import glsl from 'highlight.js/lib/languages/glsl';
import { AppProps } from 'next/app';
import Image from 'next/image';
import Script from 'next/script';

import { MDXProvider } from '@mdx-js/react';
import * as React from 'react';

import '../styles/index.css';
import typography from '../utils/typography/typography';
import { useGtag } from './gtag';
import type { ComponentProps } from 'react';

hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('typescript', typescript);
hljs.registerLanguage('glsl', glsl);
hljs.registerAliases(['ts', 'tsx'], { languageName: 'typescript' });

const ResponsiveImage = (props: ComponentProps<'img'>) => {
  const {
    src = '',
    alt = '',
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    width,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    height,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    // placeholder,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref,
    ...rest
  } = props;
  // console.log({ src });
  // if (src.endsWith('mp4')) {
  //   return (
  //     <video
  //       className="shadow"
  //       width={0}
  //       height={0}
  //       style={{ width: '100%', height: 'auto' }}
  //       src={src}
  //       placeholder={'blur'}
  //     />
  //   );
  // }
  return (
    <Image
      className="shadow"
      sizes="100vw"
      width={0}
      height={0}
      style={{ width: '100%', height: 'auto' }}
      src={src as string}
      alt={alt}
      // placeholder={'blur'}
      {...rest}
    />
  );
};

const components = {
  img: ResponsiveImage,
  // code: (props) => {
  //   console.log(props);
  //   return <code {...props}>{}</code>;
  // },
};

function MyApp({ Component, pageProps }: AppProps) {
  useGtag();
  return (
    <>
      {/* eslint-disable-next-line react/no-unknown-property */}
      <style global jsx>
        {`
          ${typography.createStyles()}
          .markdown {
            color: #3d3d3d;
          }
          .markdown ul li {
            list-style-type: disc;
          }
          .markdown ol {
            list-style-type: decimal;
          }
          :not(pre) code {
            background-color: rgb(203 208 218);
            // rgb(179 198 239);
            border-radius: 3px;
            font-family: D2Coding, Consolas, 'Roboto Mono', 'Liberation Mono', Menlo, Courier, monospace;
            padding: 0.2rem 0.3rem;
            margin: 0 0.2rem;
          }
          .markdown * code {
            font-size: inherit;
          }
          .markdown code[class*='language-'] {
            font-family: D2Coding, Consolas, 'Roboto Mono', 'Liberation Mono', Menlo, Courier, monospace;
            padding: 1rem;
            background-color: #2d2d2d;
          }
        `}
      </style>
      <MDXProvider components={components as any}>
        <Component {...pageProps} />
      </MDXProvider>
      {process.env.NODE_ENV !== 'development' && (
        <>
          {/* <!-- Google tag (gtag.js) --> */}
          {/* @ts-ignore eslint-disable-next-line @next/next/next-script-for-ga  @next/next/next-script-for-ga */}
          <Script async src="https://www.googletagmanager.com/gtag/js?id=G-857MV9DNXY" />
          {/* @ts-ignore eslint-disable-next-line @next/next/next-script-for-ga  @next/next/next-script-for-ga */}
          <Script
            id="gtag-init"
            async
            dangerouslySetInnerHTML={{
              __html: `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', 'G-857MV9DNXY');
      `,
            }}
          />
        </>
      )}
    </>
  );
}

export default MyApp;
